import Papa from 'papaparse'

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = filename
  link.style.display = 'none'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  setTimeout(() => {
    URL.revokeObjectURL(url)
  }, 100)
}

export function exportCsv({
  rows,
  filename = 'export.csv',
  columns = null,
  header = true
}) {
  if (!Array.isArray(rows)) {
    throw new Error('CSV export failed: rows must be an array.')
  }

  if (!rows.length) {
    throw new Error('CSV export failed: there are no rows to export.')
  }

  const csv = Papa.unparse(rows, {
    columns,
    header,
    quotes: true,
    skipEmptyLines: true
  })

  // BOM helps Excel open UTF-8 CSV files correctly
  const csvWithBom = `\uFEFF${csv}`

  const blob = new Blob([csvWithBom], {
    type: 'text/csv;charset=utf-8;'
  })

  downloadBlob(blob, filename)
}
